import { charEntropy } from '@dsee/util/strings.js';


export default {
    computed: {
        safety() {
            const value = charEntropy(this.password);
            if (value < 24)
                return 'low';

            if (value < 53)
                return 'medium';

            return 'hard';
        },
        safetyHard() {
            return this.safety === 'hard';
        },
    },
};
